export default __webpack_public_path__ + "static/media/product.93f1b200.svg";